<template>
  <div id="privacy" class="body-container">
    <div class="body-content" v-show="isShow">
      <h1>隐私政策</h1>
      <div>最近更新：2022年8月8日</div>
      <div>请花一些时间熟悉我们的隐私政策，如果您有任何问题，请联系我们。</div>
      <div>大连成者科技有限公司及旗下各关联公司（以下统称“成者科技”）尊重并保护所有使用产品（包含：“成者CZUR”、“极简扫描”、“成者极简扫描”、“CZUR”等相关APP）或服务用户的个人隐私权。为了给您提供产品或服务，成者科技会按照本隐私权政策的规定使用和披露您的个人信息。但成者科技将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，成者科技不会将这些信息对外披露或向第三方提供。</div>
      <div>您在同意成者科技服务使用协议之时，即视为您已经同意本隐私权政策全部内容。本隐私权政策属于成者科技服务使用协议不可分割的一部分，成者科技会不时更新本隐私权政策，请您关注。</div>
      <div class="title">1、 我们收集哪些信息以及信息用途</div>
      <div>在您使用我们的产品或服务时，我们可能需要收集和使用的您的个人信息包括如下两种：</div>
      <div>a）为实现向您提供我们产品或服务的基本功能，您须授权我们收集、使用的必要的信息。如您拒绝提供相应信息，您将无法正常使用我们的产品或服务；</div>
      <div>b）为实现向您提供我们产品或服务的附加功能，您可选择授权我们收集、使用的信息。如您拒绝提供，您将无法正常使用相关附加功能或无法达到我们拟达到的功能效果，但并不会影响您正常使用我们产品或服务的基本功能。</div>
      <div>1）您须授权我们收集和使用您个人信息的情形</div>
      <div>a）在您使用我们产品或服务过程中，为识别账号异常状态、安全地连接和管理智能硬件、智能硬件的异常状态、了解或优化相关产品适配性、向您提供更契合您需求的页面展示和搜索结果，我们可能会自动收集您的使用情况并存储为网络日志信息；我们可能会收集您的Wi-Fi信息、IP地址、位置信息、登录帐号信息、手机相关信息、智能设备相关信息，以及帐号和智能设备的关联信息。上述各项信息，详细列举如下：</div>
      <div class="sub-p">• 成者科技登录帐号信息：帐号、昵称、头像信息。</div>
      <div class="sub-p">• 手机相关信息：硬件设备标识(设备硬件序列号、Mac地址、Android ID)、系统版本信息、系统语言。</div>
      <div class="sub-p">• 通过Wi-Fi或蓝牙连接的智能硬件设备：Wi-Fi信息（SSID,BSSID, Wi-Fi的Mac地址、Wi-Fi密码）、设备蓝牙Mac地址、设备ID、设备系统版本信息、系统语言、系统使用设置</div>
      <div>b）为了使您持续享受最新的服务，我们可能会使用您的“成者CZUR”应用的版本信息。同时，我们可能收集您已连接的智能设备列表和版本号信息，用于为您提供智能设备的升级功能，以确保您可以使用最新版本的服务（包括固件版本）。</div>
      <div>2）您可选择是否授权我们收集和使用您的个人信息的情形</div>
      <div>为使您更好的体验智能硬件设备的使用、控制、管理等，我们的以下附加功能中可能会收集和使用您的个人信息。如果您不提供这些个人信息，您依然可以使用基础服务，但您可能无法使用这些可以为您所带来便利的附加功能。这些附加功能包括：</div>
      <div>a）人脸识别管理</div>
      <div>如果您通过“成者CZUR”连接了支持人脸识别功能的特定产品（如“明镜Mirror” 智能坐姿仪系列、“Auramate” 智能陪伴仪系列等产品），您可以录入人脸及坐姿图像进行更好的智能设备使用体验（识别自定义姿势、识别有人使用设备的报告）。您可以录入需要识别的人脸素材，您可以在对应的产品功能里来添加和删除人脸及坐姿图像。 如果您对我们识别的结果有疑问，您可以和我们反馈以帮助我们优化算法和模型。在此情况下，我们会收集您主动反馈的问题的图文信息。请您放心，您反馈的信息仅会用于优化算法和模型，不会用于其他用途。</div>
      <div>b） 用户反馈：</div>
      <div>我们可能收集您发给我们的反馈的问题、反馈日志，以及您填写的电话号码或邮箱，这些信息将用于让我们更好的了解您遇到的问题，以及联系您。</div>
      <div class="title">2. 信息披露</div>
      <div>在如下情况下，成者科技将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：</div>
      <div>a) 经您事先同意，向第三方披露；</div>
      <div>b) 为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；</div>
      <div>c) 根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；</div>
      <div>d) 如您出现违反当地国家有关法律、法规或者成者科技服务协议或相关规则的情况，需要向第三方披露；</div>
      <div>e) 如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；</div>
      <div>f) 在成者科技平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，成者科技有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决。</div>
      <div>g) 其它成者科技根据法律、法规或者网站政策认为合适的披露。</div>
      <div class="title">3. 征得授权同意的例外</div>
      <div>根据相关法律法规规定，以下情形中收集您的信息无需征得您的授权同意：</div>
      <div>a）与国家安全、国防安全有关的；</div>
      <div>b）与公共安全、公共卫生、重大公共利益有关的；</div>
      <div>c）与犯罪侦查、起诉、审判和判决执行等有关的；</div>
      <div>d）出于维护信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</div>
      <div>e）所收集的信息是您自行向社会公众公开的；</div>
      <div>f）从合法公开披露的信息中收集信息的，如合法的新闻报道、政府信息公开等渠道；</div>
      <div>g）根据您的要求签订合同所必需的；</div>
      <div>h）用于维护成者科技服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</div>
      <div>i）为合法的新闻报道所必需的；</div>
      <div>j）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的信息进行去标识化处理的；</div>
      <div>k）法律法规规定的其他情形。</div>
      <div class="title">4. 信息存储和交换</div>
      <div>成者科技收集的有关您的信息和资料将保存在成者科技及（或）其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或成者科技收集信息和资料所在地的境外并在境外被访问、存储和展示。</div>
      <div class="title">5. Cookie的使用</div>
      <div>a) 在您未拒绝接受cookies的情况下，成者科技会在您的计算机上设定或取用cookies，以便您能登录或使用依赖于cookies的成者科技平台服务或功能。</div>
      <div>b) 您有权选择接受或拒绝接受cookies。您可以通过修改浏览器设置的方式拒绝接受cookies。但如果您选择拒绝接受cookies，则您可能无法登录或使用依赖于cookies的成者科技网络服务或功能。</div>
      <div>c) 通过成者科技所设cookies所取得的有关信息，将适用本政策。</div>
      <div class="title">6、 信息安全</div>
      <div>a) 成者科技帐号均有安全保护功能，请妥善保管您的用户名及密码信息。成者科技将通过对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您注意在信息网络上不存在“完善的安全措施”。</div>
      <div>b) 在使成者科技网络服务进行网上交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是成者科技用户名及密码发生泄露，请您立即联络成者科技客服，以便成者科技采取相应措施。</div>
      <div>c) 成者科技不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该第三方和成者科技（含成者科技关联公司）单独或共同为您提供服务，且在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些资料。</div>
      <div>d) 成者科技亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何成者科技平台用户如从事上述活动，一经发现，成者科技有权立即终止与该用户的服务协议。</div>
      <div class="title">7. 软件隐私权限说明</div>
      <div>a) 显示弹框、全屏界面到其他应用上面。</div>
      <div>b) 允许应用修改或删除存储卡上的照片、媒体内容和文件。</div>
      <div>c) 允许应用基于GPS、基站、 Wi-Fi 等网络源获取位置信息。这可能会增加耗电量。</div>
      <div>d) 允许应用在后台运行时检索用户位置信息。</div>
      <div>e) 允许应用录制音频。</div>
      <div>f) 允许应用拍摄照片和视频。</div>
      <div>g) 允许应用读取存储卡上的照片、媒体内容和文件。</div>
      <div>h) 允许应用获取本机号码、通话状态以及拨打的号码。</div>
      <div>i) 修改设置应用中的设置项。</div>
      <div>j) 允许应用打开蓝牙权限，连接ble蓝牙设备。</div>
      <div>k) 为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的广播信息，本应用须使用(自启动)力，将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为，是因实现功能及服务所必要的。</div>
      <div class="title">8. 第三方服务收集的信息和安全保障功能</div>
      <div>a)com.tencent.bugly(Bugly;腾讯Bugly)；收集信息：需要网络权限和存储权限，搜集brand、model等基本设备信息；使用目的：提供异常日志分析服务；收集方式：SDK对手机进行本地采集</div>
      <div>b) com.huawei.hms(华为;华为推送)；收集信息：唯一设备识别码、Token、网络信息；使用目的：信息推送；收集方式：SDK对手机进行本地采集；</div>
      <div>c) com.sina.weibo(微博;新浪微博)；收集信息：设备信息；使用目的：用于分享，第三方登录；收集方式：SDK对手机进行本地采集；</div>
      <div>d) com.umeng(友盟)；收集信息：设备信息，用户的IMSI信息； 使用目的：用于第三方（微信、QQ）共享登录，分享；收集方式：SDK对手机进行本地采集；</div>
      <div>e) com.huawei.agconnect(华为;华为联运应用)；收集信息：设备信息；使用目的：华为应用市场分发服务；收集方式：SDK对手机进行本地采集；</div>
      <div>f) cn.jpush.android(极光;极光推送)；收集信息：设备信息、地理位置、网络信息；使用目的：信息推送；收集方式：SDK对手机进行本地采集；</div>
      <div>g)com.tencent.mm(微信)；收集信息：MAC地址、唯一设备识别码；使用目的：购买VIP服务等；收集方式：SDK对手机进行本地采集；</div>
      <div>h)com.eg.android.AlipayGphone(支付宝)；收集信息：设备信息（如IMEI、IMSI、SIM卡序列号、MAC地址、AndroidID、SSID、BSSID、设备基础信息【机型\厂商等】）、网络信息；使用目的：购买VIP服务等；收集方式：SDK对手机进行本地采集；</div>
      <div>i) com.xiaomi.mipush(小米;小米推送)；收集信息：唯一设备识别码、Token、网络信息；使用目的：信息推送；收集方式：SDK对手机进行本地采集；</div>
      <div>j) com.heytap.mcs(OPPO;OPPO推送)；收集信息：唯一设备识别码、Token、网络信息；使用目的：信息推送；收集方式：SDK对手机进行本地采集；</div>
      <div>k) com.vivo.push(VIVO;VIVO推送)；收集信息：唯一设备识别码、Token、网络信息；使用目的：信息推送；收集方式：SDK对手机进行本地采集；</div>
      <div>l) io.agora(声网) ；收集信息：设备类型、设备型号、CPU信息、电池电量信息、操作系统信息收发端用户ID、用户属性、频道信息、使用时长、频道内设置名称、日志；使用目的：提供视频与音频会议功能；收集方式：SDK对手机进行本地采集；</div>
      <div>查看详细说明也可访问 <a href="https://passport.czur.cc/3dsharelist.html">https://passport.czur.cc/3dsharelist.html</a></div>
      <!-- <div>i)com.eg.android.AlipayGphone(支付宝)；设备信息（如IMEI、IMSI、SIM卡序列号、MAC地址、AndroidID、SSID、BSSID、设备基础信息【机型\厂商等】）、网络信息；</div> -->
      <div class="title">9. 适用于某些国家/地区的特别规定</div>
      <div>在中国（为本条款之目的，不包含港澳台地区）运营中收集和产生的个人信息遵守《中华人民共和国网络安全法》关于关键信息基础设施个人信息和重要业务数据出境的相关规定。 在中国香港特别行政区、澳门特别行政区和台湾地区，我们的产品和服务将遵守包括《香港个人资料（私隐）条例》在内的该等各地区的可适用法律规范的要求。</div>
      <div>在《欧盟通用数据保护条例》（EU General Data Protection Regulation）对我们提供的服务可适用的情形下，我们承诺，您同时享有该条例项下的相关权益，包括但不限于数据访问权（您可以从我们处获得关于是否正在处理与您有关的个人数据、处理地点以及处理目的的确认等）、数据迁移权（在有关条件下，依照您的请求，我们将向您提供符合该条例规定的形式的您的数据，或向指定的其他数据控制者传输您的数据）、被遗忘权（在有关条件下，依照您的请求，我们将无不当延误地删除所有有关您的个人数据）。</div>
      <div>在美国，我们的产品和服务将遵守包括美国《隐私权法案》（Privacy Act）、《电子通信隐私法案》（Electronic Communications Privacy Act）、《儿童在线隐私保护法案》（Children's Online Privacy Protection Act）在内的可适用法律规范的要求。</div>
      <div>如果可适用法律规范所规定的您的有关权益与本《隐私政策》的内容有不符之处，以该可适用法律规范的规定为准，但前述可适用法律规范的规定如与本《隐私政策》约定的适用法律的强制性规定有冲突处，我们将在优先遵守该等强制性规定的前提下，尽可能遵守该可适用法律规范的规定。</div>
      <div class="title">10. 通知和修订</div>
      <div>我们可能适时修改本《隐私政策》的条款，该等修改构成本《隐私政策》的一部分。对于重大变更，我们会提供更显著的通知，您可以选择停止使用成者科技服务；在该种情况下，如您仍然继续使用成者科技服务的，即表示同意受经修订的本《隐私政策》的约束。</div>
      <div>任何修改都会将您的满意度置于首位。我们鼓励您在每次使用成者科技服务时都查阅我们的隐私政策。</div>
      <div>我们可能在必需时（例如当我们由于系统维护而暂停某一项服务时）发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于推广的公告。</div>
      <div>最后，您必须对您的账号和密码信息负有保密义务。任何情况下，请小心妥善保管。</div>
      <div class="title">11. 注销服务或帐号</div>
      <div>如您需要注销您的成者帐号，您可以在【我的-用户协议和隐私政策-注销账号】提交注销申请，并根据提示进行注销流程。由于注销成者帐号的操作将使您无法使用成者产品和服务，请您谨慎操作。</div>
      <div class="title">12. 如何联系我们</div>
      <div>如您有关于网络信息安全的投诉和举报，或您对本《隐私政策》、您的信息的相关事宜有任何问题、意见或建议，以及有关本声明或成者科技的隐私措施的问题请与成者科技的协调人联系。</div>
      <div>电子邮箱： <a href="mailto:service@czur.com">service@czur.com</a></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'privacy',
  data () {
    return {
      isShow: false
    }
  },
  mounted () {
    // this.$nextTick(() => {
    //   this.isShow = true
    // })
    setTimeout(() => {
      this.isShow = true
    }, 100)
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
#privacy
  margin .25rem
  font-size 0.18rem
  line-height 0.24rem
  text-align justify
  height auto
  h1

    margin-top 0.5rem
    font-weight bold
    // font-size 0.26rem
    font-size 0.2rem
  div
    text-indent 0.31rem
    margin .1rem 0
    &.title
      text-indent 0
      font-weight bold
      font-size 0.2rem
    &.sub-p
      text-indent 0.59rem
    a
      color #000
      &:hover
        color #0982cb
</style>



// WEBPACK FOOTER //
// privacy_CZUR.vue?40a331e2